(() => {
  const enable = true;
  const pushGA4 = (eventName, eventParameters) => {
    if (!enable) return;
    const payload = {
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: eventParameters,
    };

    try {
      if (typeof GA4Initializer !== 'undefined' && typeof GA4Initializer.push === 'function') {
        GA4Initializer.push(payload);
        return;
      }
    } catch (_) {}

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push(payload);
  };

  const pushAddToCart = ({ itemId, itemName, price, currency }) => {
    pushGA4('add_to_cart', {
      item_id: itemId != null ? String(itemId) : '',
      item_name: itemName || '',
      price: typeof price === 'number' ? price : Number(price) || 0,
      currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
    });
  };

  const pushLearnMore = ({ itemId, itemName, section }) => {
    pushGA4('learn_more', {
      item_id: itemId != null ? String(itemId) : '',
      item_name: itemName || '',
      section: section || '',
    });
  };

  const initPilatesAnalytics = () => {
    if (document.body.dataset.pilatesAnalyticsReady === 'true') return;
    document.body.dataset.pilatesAnalyticsReady = 'true';
  };

  window.PilatesAnalytics = {
    push: pushGA4,
    pushAddToCart,
    pushLearnMore,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPilatesAnalytics);
  } else {
    initPilatesAnalytics();
  }

  document.addEventListener('shopify:section:load', initPilatesAnalytics);
})();
